document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".solar-calculator");

  sections.forEach(function (section) {
    initSolarCalculator(section);
  });

});

function initSolarCalculator(section) {

  // Leer datos del producto desde el script JSON embebido
  const sectionId = section.id.replace("solar-calculator-", "");
  const dataScript = document.getElementById("solar-product-data-" + sectionId);

  if (!dataScript) return;

  let productData;
  try {
    productData = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error("Error leyendo datos del producto solar:", e);
    return;
  }

  // Leer configuración desde data attributes de la sección
  const kwhPrice       = parseFloat(section.dataset.kwh)             || 232;
  const equivalentPrice = parseFloat(section.dataset.equivalentPrice) || 4990;
  const equivalentPower = parseFloat(section.dataset.equivalentPower) || 5;
  const defaultHours   = parseFloat(section.dataset.hours)           || 8;
  const analysisYears  = parseFloat(section.dataset.years)           || 5;

  // Poblar datos del producto
  const image   = document.getElementById("SolarProductImage-" + sectionId);
  const title   = document.getElementById("solarProductTitle");
  const price   = document.getElementById("solarProductPrice");
  const buttonTop = document.getElementById("solarProductButton");
  const buyButton = document.getElementById("buyButton");

  if (image && productData.image)  image.src = productData.image;
  if (image)                       image.alt = productData.title || "";
  if (title)                       title.textContent = productData.title || "";
  if (price)                       price.textContent = formatCurrency(productData.price || 0);
  function addToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(function (response) { return response.json(); })
    .then(function (item) {
      // Disparar evento nativo del tema para actualizar el carrito
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

      // Intentar abrir el drawer del carrito si existe
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();
      }

      const btn = document.getElementById("solarProductButton");
      const buy = document.getElementById("buyButton");
      if (btn) btn.textContent = "✓ Agregado";
      if (buy) buy.textContent = "✓ Agregado";

      window.location.href = window.location.pathname + "#solar-calculator-" + sectionId;

    })
    .catch(function (err) {
      console.error("Error al agregar al carrito:", err);
    });
  }



  if (buttonTop) {
    buttonTop.addEventListener("click", function () {
      addToCart(productData.variantId);
    });
  }

  if (buyButton) {
    buyButton.addEventListener("click", function () {
      addToCart(productData.variantId);
    });
  }


  // Estado
  let currentQuantity = 6;
  let currentHours    = defaultHours;
  let currentKwh      = kwhPrice;

  // Controles
  const quantitySlider = document.getElementById("solarQuantity");
  const quantityValue  = document.getElementById("quantityValue");
  const kwhInput       = document.getElementById("kwhPrice");
  const hourButtons    = section.querySelectorAll(".hour-button");

  if (quantitySlider) {
    quantitySlider.addEventListener("input", function () {
      currentQuantity = parseInt(this.value);
      if (quantityValue) quantityValue.textContent = currentQuantity;
      updateResults();
    });
  }

  if (kwhInput) {
    kwhInput.addEventListener("input", function () {
      currentKwh = parseFloat(this.value) || kwhPrice;
      updateResults();
    });
  }

  hourButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      hourButtons.forEach(function (b) { b.classList.remove("active"); });
      this.classList.add("active");
      currentHours = parseFloat(this.dataset.hours) || defaultHours;
      updateResults();
    });
  });

  // Calcular y mostrar resultados
  function updateResults() {

    const productPrice   = productData.price || 0;
    const solarCostTotal = productPrice * currentQuantity;

    // Consumo anual de la alternativa eléctrica (kWh)
    const annualConsumption = (equivalentPower / 1000) * currentHours * 365 * currentQuantity;

    // Costo anual electricidad
    const annualElectricityCost = annualConsumption * currentKwh;

    // Costo total eléctrico (compra + electricidad en N años)
    const electricPurchase = equivalentPrice * currentQuantity;
    const electricityTotal = annualElectricityCost * analysisYears;
    const electricTotal    = electricPurchase + electricityTotal;

    // Ahorro
    const annualSaving    = annualElectricityCost;
    const totalSaving     = annualSaving * analysisYears;
    const payback         = annualSaving > 0 ? (solarCostTotal - (currentQuantity * (productPrice -  7000))) / annualSaving: 0;

    // CO₂ (factor promedio Chile: ~0.4 kg CO₂/kWh)
    const co2Saved = annualConsumption * 0.4 * analysisYears;

    // Actualizar DOM
    setText("annualSaving",      formatCurrency(annualSaving));
    setText("fiveYearSaving",    formatCurrency(totalSaving));
    setText("payback",           payback.toFixed(1) + " años");
    setText("solarCost",         formatCurrency(solarCostTotal));
    setText("annualConsumption", annualConsumption.toFixed(1) + " kWh");
    setText("co2Saved",          co2Saved.toFixed(1) + " kg");

    // Tabla comparativa
    setText("tableSolarPurchase",    formatCurrency(solarCostTotal));
    setText("tableElectricPurchase", formatCurrency(electricPurchase));
    setText("tableElectricity",      formatCurrency(electricityTotal));
    setText("tableSolarTotal",       formatCurrency(solarCostTotal));
    setText("tableElectricTotal",    formatCurrency(electricTotal));
  }

  // Inicializar con valores por defecto
  updateResults();
}

function setText(id, value) {
  const el = document.getElementById(id);
  if (el) el.textContent = value;
}

function formatCurrency(value) {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0
  }).format(value);
}
